import { Navigate } from 'react-router-dom';
import { isUserAuthenticated, isDoctorAuthenticated, isAdminAuthenticated } from '../utils/auth';

/** Fresh auth check on every render (avoids stale App.js route elements). */
export function UserProtectedRoute({ children }) {
  if (!isUserAuthenticated()) {
    return <Navigate to="/user/login" replace />;
  }
  return children;
}

export function DoctorProtectedRoute({ children }) {
  if (!isDoctorAuthenticated()) {
    return <Navigate to="/doctor/login" replace />;
  }
  return children;
}

export function AdminProtectedRoute({ children }) {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
